/* eslint-disable react/no-array-index-key */
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../../modules/infra/i18n';
import Icon, { GLYPHS } from '../../../../common/icon';
import steps from '../PoFormSteps';

const PoFormHeader = ({ activeStep }) => (
  <div className="c-breadcrumbs">
    {steps.map((step, idx) => (
      <div key={idx} className={cx('o-flexbox o-flexbox--content-align-center', { 'is-active': activeStep === idx })}>
        <div className="u-mr-">{t(step.title)}</div>
        <Icon className="u-mr-" glyph={GLYPHS.navigationArrow} display-if={idx < steps.length - 1} />
      </div>
    ))}
  </div>
);

PoFormHeader.propTypes = {
  activeStep: PropTypes.number.isRequired,
};

export default PoFormHeader;
